<template>
  <div id="class_teacherlist" :style="{width: width}">
    <swiper :options="swiperOption" v-if="teacherListSwiper.length > 0">
      <swiper-slide class="mapimg" v-for="(item, index) in teacherListSwiper" :key="index">
        <div class="teacherinfo" @click="findTeacherInfo(item.unique_name)">
          <div class="teacherimg">
            <img :src="item.picture|defaultTeacherImg(item.picture, item.gender)" :alt="item.teacher_name" />
          </div>
          <div class="teachername">{{item.teacher_name}}</div>
          <i class="fa fa-chevron-right"></i>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev" slot="button-prev" v-show="btnState"></div>
    <div class="swiper-button-next" slot="button-next" v-show="btnState"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: {
    teacherListSwiper: Array,
    sum: Number,
    width: String
  },
  data: function () {
    return {
      manpic: require('@/assets/img/class/teacher-nan.png'),
      womanpci: require('@/assets/img/class/teacher-nv.png'),
      list: [],
      swiperOption: {
        slidesPerView: this.sum,
        notNextTick: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许点击小圆点跳转
        },
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next'
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      }
    }
  },
  filters: {},
  methods: {
    findTeacherInfo (e) {
      const APP = process.env.VUE_APP_ZT_URL
      window.open(APP + '/teacherdetail/' + e)
    }
  },
  computed: {
    btnState () {
      return this.teacherListSwiper.length >= this.sum
    }
  },
  components: {
    swiper,
    swiperSlide
  }
}
</script>
<style lang="css">
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after  {
  content: '' !important;
  }
.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{
    content: ''!important;
  }
#class_teacherlist {
  position: relative;
  height: 70px;
  box-sizing: border-box;
  padding: 0px 30px;
  background: white;
  display: flex;
  align-items: center;
}
#class_teacherlist .swiper-container {
  width: 100%;
}
#class_teacherlist .swiper-slide {
  /* width: 113px; */
  width: auto !important;
}
#class_teacherlist .teacherimg {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  text-align: center;
}
#class_teacherlist .teacherimg img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

#class_teacherlist .teacherinfo {
  display: flex;
  align-items: center;
  cursor: pointer;
}
#class_teacherlist .teacherinfo .fa {
  margin-top: 3px;
  color: rgba(51, 51, 51, 0.2);
  font-size: 18px;
  margin-right: 30px;
}
#class_teacherlist .teacherinfo .teachername {
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.8);
  height: 16px;
  overflow: hidden;
  margin-left: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
}
#class_teacherlist .teacherinfo .teachername i {
  color: rgba(51, 51, 51, 0.2);
  position: relative;
  top: 2px;
  left: 5px;
}

#class_teacherlist .swiper-button-prev {
  background-image: url("../assets/img/class/zuo.png");
  border: 1px solid rgba(51, 51, 51, 0.1);
  background-size: auto;
  width: 12px;
  height: 50px;
  border-radius: 3px;
}
#class_teacherlist .swiper-button-next {
  background-image: url("../assets/img/class/you.png");
  background-size: auto;
  border: 1px solid rgba(51, 51, 51, 0.1);
  width: 12px;
  height: 50px;
  border-radius: 3px;
}
</style>
